/**
 * Constantes de colores del sistema
 * Sincronizadas con src/assets/css/_variables.scss ($principal, $secundario)
 *
 * Color principal: #d81b60 · Secundario: #FEDEDE
 */

export const COLORS = {
  /** Color principal del sistema */
  principal: '#d81b60',

  /** Superficie / acento suave (alineado al secundario SCSS) */
  secundario: '#FEDEDE',

  /**
   * Paleta para PrimeNG (primary palette).
   * 500 = color principal; 50–400 más claros; 600–900 más oscuros.
   */
  primary: {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#d81b60',
    600: '#c2185b',
    700: '#ad1457',
    800: '#880e4f',
    900: '#560027',
  },
} as const;
